import api from 'Application/api/api';

const logout = (cancelToken = null) => api.post('/logout', {}, { cancelToken });

export default logout;
